export default __webpack_public_path__ + "static/media/messagerie.b650be97.svg";